import { render, staticRenderFns } from "./AddCashRegisterPage.vue?vue&type=template&id=c780074a"
import script from "./AddCashRegisterPage.vue?vue&type=script&lang=js"
export * from "./AddCashRegisterPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports